import moment from "moment-timezone";

export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://app.quickquery.com.au:3033/api/v1";

export const SOCKET_BASE_URL =
  process.env.REACT_APP_BASE_URL_SOCKET || "https://app.quickquery.com.au";

export const VAPID_PUBLIC_KEY =
  "BFzC9kJoR8b2d9OtFuAhX4aXhWCaa0x7SRsr1MZfEbEG3aFxbdaO8FXuSgZvrpRzK3OzH1iCCQjWYUVdxnxQgi0";

export const VAPID_PRIVATE_KEY = "5H4xE7O7CPYqkiPjohU-8voET6q7k1aAV3lwfowmX90";

export const VAPID_EMAIL = "mailto:kiran@wethinkdigital.com.au";

export function formatDateFromCustomString(dateString) {
  if (
    !dateString ||
    typeof dateString !== "string" ||
    dateString.trim() === ""
  ) {
    return "-";
  }

  const matches = dateString.match(/\/Date\((\d+)([+-]\d+)\)\//);

  if (matches) {
    const timestamp = parseInt(matches[1], 10);
    const timezoneOffset = parseInt(matches[2], 10);

    const date = new Date(timestamp);
    date.setMinutes(date.getMinutes() + timezoneOffset);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }

  const isoMatch = dateString.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day}/${month}/${year}`;
  }

  return dateString; // avoid showing raw junk
}

export function validateTotal(lineItems = [], finalTotal = 0, taxType = "") {
  let subTotal = 0;
  let tax = 0;
  let total = 0;

  lineItems.forEach((item) => {
    const quantity = Number(item.Quantity) || 0;
    const unitAmount = Number(item.LineAmount) || 0;
    const taxAmount = Number(item.TaxAmount) || 0;

    const lineAmount = unitAmount;
    subTotal = Math.round((subTotal + lineAmount + Number.EPSILON) * 100) / 100;
    tax += taxAmount;
  });
  total = Number(subTotal.toString());

  if (taxType === "Exclusive") {
    if (subTotal == finalTotal) {
      return true;
    } else {
      return false;
    }
  } else if (taxType === "Inclusive") {
    if (subTotal == finalTotal) {
      return true;
    } else {
      return false;
    }
  } else {
    if (subTotal == finalTotal) {
      return true;
    } else {
      return false;
    }
  }
}

export const formatToYMD = (dateString) => {
  if (!dateString) return "";
  return dateString.split("T")[0];
};

export const formatDateType1 = (dateString) => {
  if (!dateString || typeof dateString !== "string") return "";

  const date = new Date(dateString.trim());
  if (isNaN(date)) return "";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short", // "Aug"
    year: "numeric",
  });
};

export const toXeroDate = (dateValue) => {
  const d = new Date(dateValue);
  if (isNaN(d)) return null;
  return d.toISOString().split("T")[0];
};

export const parseXeroDate = (dateStr) => {
  if (!dateStr) return "";

  // Example: /Date(1732492800000+0000)/
  const match = dateStr.match(/\/Date\((\d+)(?:[+-]?\d+)?\)\//);

  if (!match) return "";

  const timestamp = Number(match[1]);
  const date = new Date(timestamp);

  return date.toISOString().split("T")[0];
};

export const replaceBKLabel = (message) => {
  if (!message) return message;

  // Replace "@Name BK" → "@Bookkeeper"
  return message
    .replace(/@([A-Za-z]+(?:\s+[A-Za-z]+)*)\sBK\b/gi, "@Bookkeeper")
    .replace(/@([A-Za-z]+(?:_[A-Za-z]+)+)_bk\b/gi, "@Bookkeeper");
};

export const getUserId = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));

  if (userDetails && userDetails.UserID) {
    return userDetails;
  } else {
    return null;
  }
};

export const formatMentionMessage = (messageContent) => {
  if (!messageContent) return messageContent;

  return messageContent.replace(
    /@([A-Za-z]+(?:_[A-Za-z]+)*)_bk\b/gi,
    (_, name) => `@${name.replace(/_/g, " ")}`,
  );
};
export const formatMoney = (amount, currencySymbol = "", fallback = "-") => {
  // Handle null / undefined / empty
  if (amount === null || amount === undefined || amount === "") {
    return fallback;
  }

  const value = Number(amount);

  // Handle NaN
  if (!Number.isFinite(value)) {
    return fallback;
  }

  return (
    currencySymbol +
    value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};

export const formatDateToDDMMYYYY = (input) => {
  let date;

  if (typeof input === "string" && input.startsWith("/Date(")) {
    const timestamp = input.match(/\d+/)[0];
    date = new Date(Number(timestamp));
  } else {
    date = new Date(input);
  }

  if (isNaN(date.getTime())) {
    return null;
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const toUpperCaseText = (text) => {
  return text ? text.toUpperCase() : "";
};

export const formatLabel = (text) => {
  if (!text) return "";
  return text
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
    .join(" ");
};

export const capitalizeFirstChar = (text) => {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
};

export const getCurrentLoginUserId = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetail"));

  if (userDetails && userDetails.UserID) {
    return userDetails.UserID;
  } else {
    return null;
  }
};

export const getCurrentLoginUserOrganisationID = () => {
  const OrganisationID = localStorage.getItem("OrganisationID");

  if (OrganisationID) {
    return OrganisationID;
  } else {
    return null;
  }
};

export const getBillsParams = ({
  page = 1,
  limit = 50,
  filters = [],
  sort = [],
  SupplierName = "",
  Reference = "",
  Description = "", // 👈 add this
  Status = "",
  Collaborator = "",
  Spend = "",
  Receive = "",
  minDate = "",
  MaxDate = "",
  AccountID = "",
  search = "",
  latestRecords = false,
  CurrencyCode = "",
} = {}) => {
  const OrganisationID = getLocalStorageValue("OrganisationID");
  const currentUser = getUserId();

  return {
    OrganisationID,
    page,
    limit,
    role_name: currentUser?.Role?.Name || "User",
    UserId: currentUser?.UserID,
    SupplierName,
    Reference,
    Description, // 👈 add this
    Status,
    Collaborator,
    Spend,
    Receive,
    minDate,
    MaxDate,
    filters,
    sort,
    AccountID,
    search,
    latestRecords,
    CurrencyCode,
  };
};

export const calculateUnitAmount = (taxType, gstCode, amount, isOpen) => {
  if (taxType == "Exclusive") {
    const gst10PercentCodes = ["INPUT", "OUTPUT", "CAPEXINPUT"];
    const isGstApplicable = gst10PercentCodes.includes(gstCode);
    if (isGstApplicable) {
      const total = amount + amount * 0.1;
      const rounded = Math.round((total + Number.EPSILON) * 100) / 100;
      return Number(rounded.toString());
    } else {
      return amount;
    }
  } else {
    return amount;
  }
};

export const calculateReverseUnitAmount = (
  taxType,
  gstCode,
  amount,
  isOpen,
) => {
  if (taxType == "Exclusive") {
    const gst10PercentCodes = ["INPUT", "OUTPUT", "CAPEXINPUT"];
    const isGstApplicable = gst10PercentCodes.includes(gstCode);
    if (isGstApplicable) {
      return Math.round((amount / 1.1 + Number.EPSILON) * 100) / 100;
    } else {
      return amount;
    }
  } else {
    return amount;
  }
};

export const calculateAmount = (taxType, gstCode, amount) => {
  if (taxType == "Exclusive") {
    const gst10PercentCodes = ["INPUT", "OUTPUT", "CAPEXINPUT"];
    const isGstApplicable = gst10PercentCodes.includes(gstCode);
    if (isGstApplicable) {
      return amount * 0.1 + amount;
    } else {
      return amount;
    }
  } else {
    return amount;
  }
};

export const calculateGSTAmount = (amount1, amount2) => {
  return amount1 - amount2;
};

export const getLocalStorageValue = (key) => {
  return localStorage.getItem(key) || null;
};

export const setLocalStorageValue = (key, value) => {
  localStorage.setItem(key, value);
};

export const removeLocalStorageValue = (key) => {
  localStorage.removeItem(key);
};

export const formatDateTime = (timestamp, timezone = "Australia/Sydney") => {
  if (!timestamp) return "";

  const formattedDate = moment(timestamp)
    .tz(timezone)
    .format("ddd DD MMM YYYY");
  const formattedTime =
    moment(timestamp).tz(timezone).format("hh:mm A") + " (SYD/MEL Time)";

  return `${formattedDate}\n${formattedTime}`;
};

export const formatDateTimeDate = (
  timestamp,
  timezone = "Australia/Sydney",
) => {
  if (!timestamp) return "";

  const formattedDate = moment(timestamp)
    .tz(timezone)
    .format("ddd DD MMM YYYY");

  return `${formattedDate}`;
};

export const formatDate = (timestamp, timezone = "Australia/Sydney") => {
  if (!timestamp) return "";

  const formattedDate = moment(timestamp).tz(timezone).format("DD MMM YYYY");

  return formattedDate;
};

export const summarizeText = (text, charLimit = 7) => {
  if (!text || typeof text !== "string") return "";
  return text.length <= charLimit ? text : text.slice(0, charLimit) + "...";
};

export const getInitials = (name) => {
  if (!name) return "";

  const words = name.trim().split(" ");
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  const firstInitial = words[0].charAt(0).toUpperCase();
  const lastInitial = words[1].charAt(0).toUpperCase();

  return `${firstInitial}${lastInitial}`;
};
